const price = {
  shipmentPriceVat: 895,
  shipmentPriceNoVat: 740,
  priceFirstSheet: 120,
  priceNextSheet: 35,
  deliveryPrice: 480,
  vat: 21
}

const draft = {
  draftId: 'demo-draft-001',
  documentName: 'contract.pdf',
  description: '',
  uploadTime: '2026-07-01T10:15:00Z',
  pages: 5,
  ownerUser: 'you@example.com',
  timesUsed: 0
}

const shipmentBody = {
  emissionTime: '2026-07-01T10:30:00Z',
  cancelTime: null,
  pages: [{ draftId: draft.draftId, pageFirst: 1, pageLast: 5 }],
  destinationAddress: {
    who: 'Juan Perez',
    contact: 'Departamento Legal',
    phone: '+34910000000',
    identityCard: '00000000T',
    countryIso: 'ES',
    locality: 'Leganes',
    postalCode: '28914',
    streetType: 'Calle',
    streetName: 'Mayor',
    streetNumber: '1',
    streetComplements: '2 A',
    envelopeBox: null
  },
  senderAddress: {
    who: 'ACME',
    identityCard: 'B00000000',
    countryIso: 'ES',
    locality: 'Madrid',
    postalCode: '28002',
    streetType: 'Calle',
    streetName: 'Origen',
    streetNumber: '10'
  },
  features: {
    productCode: 'BCC',
    printColor: false,
    printDuplex: false,
    reference: 'ACME-2026-0001',
    price: price.shipmentPriceVat,
    priceFirstSheet: price.priceFirstSheet,
    priceNextSheet: price.priceNextSheet,
    deliveryPrice: price.deliveryPrice,
    vat: price.vat
  }
}

const shipment = {
  ...shipmentBody,
  shipmentId: '074523a4-2e3d-4815-96c4-b8e2b5bb0b88',
  shipmentCode: 'PR5UKZ4NM'
}
const cancelledShipment = { ...shipment, cancelTime: '2026-07-01T10:31:00Z' }
const returnIds = ['returnId1', 'returnId2', 'returnId3']
const feedback = ['STATE', 'STATE', 'PROOF'].map((returnType, index) => ({
  returnId: returnIds[index],
  returnType,
  description: ['Shipment delivered', 'Shipment in transit', 'Proof of delivery available'][index],
  shipmentCode: shipment.shipmentCode,
  ownerUser: 'you@example.com',
  recordedTime: ['2026-07-03T12:00:00Z', '2026-07-02T12:00:00Z', '2026-07-01T12:00:00Z'][index],
  read: false
}))
const filters = 'includeread=false&includestates=true&includeproofs=true&includecerts=true'

function jsonExample(method, path, response, body) {
  return {
    request: [
      method + ' ' + path,
      'Authorization: ******',
      ...(body === undefined ? [] : ['Content-Type: application/json', '', JSON.stringify(body, null, 2)])
    ].join('\n'),
    response: JSON.stringify(response, null, 2),
    language: 'json'
  }
}

function authExample(refresh) {
  const body = refresh ? 'demo-refresh-token-not-valid' : {
    userEmail: 'you@example.com', userPassword: 'your-password', realm: 'your-realm'
  }
  const example = jsonExample(refresh ? 'PUT' : 'POST', '/api/auth/session', {
    jwtToken: refresh ? 'demo-refreshed-jwt-token-not-valid' : 'demo-jwt-token-not-valid',
    refreshToken: refresh ? 'demo-rotated-refresh-token-not-valid' : 'demo-refresh-token-not-valid',
    mfaProvider: null
  }, body)
  example.request = [
    (refresh ? 'PUT' : 'POST') + ' /api/auth/session',
    'Content-Type: application/json',
    'X-Auth-Mode: token',
    ...(refresh ? ['Authorization: Bearer demo-jwt-token-not-valid'] : []),
    '',
    JSON.stringify(body, null, 2)
  ].join('\n')
  return example
}

export const simulatedExamples = {
  login: authExample(false),
  refresh: authExample(true),
  price: jsonExample('GET', '/api/product/products/price?billableidortitle=acme&productcode=BCC&destinationcountryiso=ES&destinationpostalcode=28914&printcolor=false&printduplex=false&pages=5&includevat=true', price),
  'shipment-upload': {
    request: [
      'POST /api/outbox/drafts',
      'Authorization: ******',
      'Content-Type: multipart/form-data; boundary=demo-boundary',
      '',
      '--demo-boundary',
      'Content-Disposition: form-data; name="files"; filename="contract.pdf"',
      'Content-Type: application/pdf',
      '',
      '[Simulated PDF bytes]',
      '--demo-boundary--'
    ].join('\n'),
    response: JSON.stringify([draft], null, 2),
    language: 'json'
  },
  'shipment-confirm': jsonExample('PUT', '/api/outbox/shipments', shipment, shipmentBody),
  'shipment-get': jsonExample('GET', '/api/outbox/shipments/PR5UKZ4NM', shipment),
  'shipment-cancel': jsonExample('PUT', '/api/outbox/shipments?sendconfirmation=false', cancelledShipment, cancelledShipment),
  'shipment-list': jsonExample('POST', '/api/outbox/shipmentlist', [
    shipment,
    { ...shipment, shipmentId: 'demo-shipment-002', shipmentCode: 'PXXDMYXXM' }
  ], ['PR5UKZ4NM', 'PXXDMYXXM']),
  'returns-count': jsonExample('GET', '/api/inbox/feedback/count?' + filters + '&includedocuments=true&includestampedcopies=true&includereports=false', 3),
  'returns-list': jsonExample('GET', '/api/inbox/feedback?pagesize=100&page=0&' + filters + '&includedocuments=false&includestampedcopies=false&includereports=false', feedback),
  'returns-states': {
    ...jsonExample('GET', '/api/inbox/feedback/states?returnids=' + encodeURIComponent(JSON.stringify(returnIds.slice(0, 2))), [
    { returnId: 'returnId1', shipmentCode: shipment.shipmentCode, stateCode: 'DEL', stateData: '{}', stage: 'DELIVERY', timestamp: '2026-07-03T12:00:00Z' },
    { returnId: 'returnId2', shipmentCode: shipment.shipmentCode, stateCode: 'WAY', stateData: '{}', stage: 'DELIVERY', timestamp: '2026-07-02T12:00:00Z' }
    ]),
    queryValue: JSON.stringify(returnIds.slice(0, 2))
  },
  'returns-read': jsonExample('PUT', '/api/inbox/feedback/read', 3, returnIds),
  'returns-download': {
    request: 'GET /api/inbox/feedbackfile/returnId3\nAuthorization: ******',
    response: 'Content-Type: application/octet-stream\nContent-Disposition: attachment; filename="feedback.pdf"\n\n[Simulated PDF bytes - no file is downloaded]',
    language: 'http'
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/api/simulatedExamples.js